// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/index'
// import { Loading } from 'element-ui';
import axios from 'axios'
import store from './store'
import fabric from 'fabric'
import EditNavAlias from './components/editNavAlias.vue'
Vue.use(fabric)
Vue.component('edit-nav-alias',EditNavAlias)
axios.defaults.withCredentials = true;

// router.beforeEach((to, from, next) => {
//   console.log('process.env.NODE_ENV', process.env.NODE_ENV);
//   next();
// })


Vue.use(ElementUI)
Vue.use(api)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  api,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js